import { useRouter, type RouteLocationRaw } from 'vue-router';
import { usePageTransitionsStore } from '../stores/pageTransitionsStore';

export function useAppRouter() {
    const router = useRouter();
    const transitions = usePageTransitionsStore();

    function push(to: RouteLocationRaw) {
        transitions.setTransition('page-forward');
        return router.push(to);
    }

    function back() {
        transitions.setTransition('page-back');
        return router.back();
    }

    function backTo(to: RouteLocationRaw) {
        transitions.setTransition('page-back');
        return router.push(to);
    }

    function fade(to: RouteLocationRaw) {
        transitions.setTransition('page-fade');
        return router.push(to);
    }

    return { push, back, backTo, fade, router };
}
